module.exports = __webpack_public_path__ + "media/mob.4b95f42d.mp4";